import React, {useState} from "react";
import ReactDOM from "react-dom";
import Calendar from "./Blocks/Calendar";

class CalendarBlock extends React.Component {
    render = () => (
        <Calendar countRender="1" reserved={[]} onClickReserve={e => {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(document.getElementById("calendar-block").dataset.scroll).offset().top
            }, 500);
        }} />
    );
}

ReactDOM.render(<CalendarBlock />, document.getElementById("calendar-block"));

if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept();
}